/* istanbul ignore file */
import { zodResolver } from '@hookform/resolvers/zod';
import {
  salesBOMFormSchema,
  type SalesBOMFormSchema,
} from '@partful/pages/create-product/sales-bom/lib/SalesBOMFormSchema';
import { SalesBOM } from '@partful/pages/create-product/sales-bom/SalesBOM';
import UploadCAD from '@partful/pages/create-product/upload-cad/UploadCAD';
import { FormProvider, useForm } from 'react-hook-form';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { Footer } from 'src/components/Footer';
import { StepDescription } from 'src/components/StepElements/StepDescription';
import { StepMenu } from 'src/components/StepElements/StepMenu';
import { MainTemplate } from 'src/templates/MainTemplate';
import GeneralAssemblyPage from './GeneralAssemblyPage/GeneralAssemblyPage';
import { MatchReportPage } from './MatchReportPage';
import { ProcessingFilePage } from './ProcessingPage/ProcessingFilePage';
import SelectPartNumber from './SelectPartNumber/SelectPartNumber';
import { SectionSpacing } from './styles';

export function CreateNewProductPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const productName = searchParams.get('productName');

  const form = useForm<SalesBOMFormSchema>({
    resolver: zodResolver(salesBOMFormSchema),
    mode: 'onChange',
  });

  return (
    <MainTemplate data-testid="create-new-product-page">
      <SectionSpacing>
        <Switch>
          <Route exact path="/create-product/cad">
            <StepMenu step={0} stepTitle="newProduct" />
            <StepDescription stepKey="detailsCAD" descriptionKey="detailsCADDescription" />
            <UploadCAD />
          </Route>
          <Route exact path="/create-product/cad/general-assembly">
            <StepMenu step={0} stepTitle={productName ?? 'newProduct'} />
            <StepDescription stepKey="selectGeneralAssembly" descriptionKey="selectGeneralAssemblyDescription" />
            <GeneralAssemblyPage />
          </Route>
          <Route exact path="/create-product/cad/processing">
            <StepMenu step={0} stepTitle={productName ?? 'newProduct'} />
            <StepDescription stepKey="Processing CAD file" descriptionKey="" />
            <ProcessingFilePage />
          </Route>
          <Route exact path="/create-product/cad/select-part-number">
            <StepMenu step={0} stepTitle={productName ?? 'newProduct'} />
            <StepDescription stepKey="selectPartNumber" descriptionKey="selectPartNumberDescription" />
            <SelectPartNumber />
          </Route>
          <Route exact path="/create-product/sales-bom">
            <StepMenu step={1} stepTitle={productName ?? 'newProduct'} />
            <StepDescription stepKey="sBOM" descriptionKey="sBOMDescription" />
            <FormProvider {...form}>
              <SalesBOM />
            </FormProvider>
          </Route>
          <Route exact path="/create-product/match-report">
            <StepMenu step={2} stepTitle={productName ?? 'newProduct'} />
            <StepDescription stepKey="matchReport.sidebarName" />
            <MatchReportPage />
          </Route>
          <Redirect to="/create-product/cad" />
        </Switch>
      </SectionSpacing>
      <Footer />
    </MainTemplate>
  );
}
